/*! Copyright (c) 2024, XAPP AI */
import { FormWidgetAppChannelInput } from "generated/graphql";
import { getApiUrl } from "./getApiUrl";
import { invertColor } from "./color";

export interface FormWidgetInput {
    name: string;
    primaryColor: string;
    secondaryColor?: string;
    appId: string;
    sideButtonLabel?: string;
}

export function generateFormWidgetInput(appInput: FormWidgetInput): FormWidgetAppChannelInput {

    const { appId, primaryColor, } = appInput;

    // Generate an inverted color for text
    const textColor = invertColor(primaryColor, true);

    const apiUrl = getApiUrl();

    const sideButtonLabel: string = appInput.sideButtonLabel || "Contact Us";

    const input: FormWidgetAppChannelInput = {
        type: "form-widget",
        name: "Schedular",
        connection: {
            serverUrl: `${apiUrl}/apps/${appId}/run`
        },
        autoGreeting: "contact us",

        sideButtonLabel,

        theme: {
            accentColor: primaryColor,

            headerBackgroundColor: primaryColor,
            headerTextColor: textColor,

            sideButton: {
                backgroundColor: primaryColor,
                color: textColor,
            },

            chips: {
                backgroundColor: primaryColor,
                color: textColor,
                colorSelected: textColor,
            },
        }
    }

    return input;
};
